import type { HeroCarouselSlideProps } from 'bundles/front-page/components/modules/hero-banner/HeroCarouselSlide';
import type { MobileHeroCardProps } from 'bundles/front-page/components/modules/slider/HeroCardContent';

import LOHPDesktopSlide1 from 'images/front-page/LOHPDesktopSlide1.png';
import LOHPHeroCourseraPlus from 'images/front-page/LOHPHeroCourseraPlus.png';
import LOHPHeroCourseraPlusMobile from 'images/front-page/LOHPHeroCourseraPlusMobile.png';
import LOHPMobileCard1 from 'images/front-page/LOHPMobileCard1.png';

import _t from 'i18n!nls/front-page';

export const getMockDesktopHeroSlideData = (): HeroCarouselSlideProps[] => [
  {
    content: {
      visual: {
        url: LOHPDesktopSlide1,
      },
      title: _t('Get job ready with new AI skills'),
      description: _t(
        'Stand out to employers with an industry-leading Professional Certificate and must-have AI skills from Google, IBM, Meta, Microsoft, and more.'
      ),
      callToActionLabel: _t('Explore certificates'),
      callToActionLink: '/explore/generative-ai',
    },
    secondaryButtonLabel: _t('Join for free'),
    secondaryButtonLink: '/?authMode=signup',
    slideTrackingName: 'lohp_desktop_hero_slide_1',
  },
  {
    content: {
      visual: {
        url: LOHPHeroCourseraPlus,
      },
      title: _t('Achieve your career goals with Coursera Plus'),
      description: _t(
        'Get access to 7,000+ courses, hands-on projects, and certificate programs from Google, Meta, Duke and more with a Coursera Plus subscription.'
      ),
      callToActionLabel: _t('Start 7-day free trial'),
      callToActionLink: '/courseraplus',
    },
    slideTrackingName: 'lohp_desktop_hero_slide_2',
    showCourseraPlusLogo: true,
    backgroundColor: 'white',
    backgroundPosition: 'center / contain',
  },
];

export const getMockMobileHeroCardData = (): MobileHeroCardProps[] => [
  {
    title: _t('Get job ready with new AI skills'),
    subtitle: _t('Stand out with a Professional Certificate'),
    primaryCtaLabel: _t('Explore certificates'),
    primaryCtaLink: '/explore/generative-ai',
    secondaryCtaLabel: _t('Join for free'),
    secondaryCtaLink: '/?authMode=signup',
    imageUrl: LOHPMobileCard1,
    backgroundColor: 'white',
  },
  {
    title: _t('Achieve your career goals with Coursera Plus'),
    primaryCtaLabel: _t('Start 7-day free trial'),
    primaryCtaLink: '/courseraplus',
    imageUrl: LOHPHeroCourseraPlusMobile,
    backgroundColor: 'white',
  },
];
